import { Col, Grid, Row } from "react-bootstrap";

import Card from "../Card/Card";
import MainContentHeader from "../Header/MainContentHeader.jsx";
import { NewButton } from "../../elements/ActionButtons/NewButton.jsx";
import React from "react";
import Spinner from "../../elements/Spinner/Spinner";
import Table from "../../elements/Table/Table";
import { injectIntl } from "react-intl";
import moment from "moment";
import { withRouter } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import SuperpositionHeader from "../../components/Header/SuperpositionHeader";
import SettingsTypeSelect from "../settings/settingsTypeSelect";

const ProjectSettingsList = ({ projectsList, intl, history, role, path, companyId, handleMinimizeSidebar }) => {
  // console.log("ProjectSettingsList", projectsList);
  const locale = `${intl.locale.split("-")[0]}`;
  if (locale !== "en") {
    // en is enabled by default already
    import(`moment/locale/${locale}`);
  }

  if (!!!projectsList) {
    return <Spinner size="lg" fullScreen />;
  }
  let projects = [];
  projectsList &&
    projectsList.map(project => {
      return projects.push({
        key: project.id,
        id: project.id,
        name: project.name,
        tiersClient:
          project.tiersClient && project.tiersClient.name
            ? project.tiersClient.name
            : "",
        projectType: project.projectType ? project.projectType : "",
        tiersCollaborator:
          project.tiersCollaborator && project.tiersCollaborator.name
            ? project.tiersCollaborator.name
            : "",
        dateFinPrevue: project.dateFinPrevue
          ? moment(project.dateFinPrevue).format("L")
          : "",
        active: project.active
          ? intl.formatMessage({ id: `ids_inProgress` })
          : intl.formatMessage({ id: `ids_finished` })
      });
    });
  return (
    <span>
      <FormattedMessage id={"ids_settings"}>
        {backBtnText => (
          <SuperpositionHeader
            backBtnText={backBtnText}
            transparent={true}
            handleMinimizeSidebar={handleMinimizeSidebar}
          >
            <div>
              <NewButton
                wd
                className="btn-fill pull-right"
                newRecordUrl={`/settings/projects/new`}
              />
            </div>
          </SuperpositionHeader>
        )}
      </FormattedMessage>

      <Grid fluid>
        {/* <MainContentHeader name="ids_projects">
          <NewButton
            wd
            className="btn-fill pull-right"
            newRecordUrl={`/settings/projects/new`}
          />
        </MainContentHeader> */}

        <div className="main-content" style={{ marginTop: "32px" }}>
          <Row>
            <div>
              <Col xs={12} sm={5} lg={5} mdOffset={3}>
                <SettingsTypeSelect
                  value={"PROJECTS"}
                  companyId={companyId}
                  intl={intl}
                  history={history}
                  role={role}
                  path={path}
                >
                </SettingsTypeSelect>
              </Col>
            </div>
          </Row>

          <div className="margin-top-40">
            <Row>
              <Col md={12}>
                <Card
                  content={
                    <Table
                      tableName="project"
                      visibleColumns={[
                        {
                          name: "active",
                          type: "categoryActive",
                          filterMethod: (filter, row) => {
                            console.log("filter", filter, row.active);
                            // return false;
                            if (filter.value === "all") {
                              return true;
                            }
                            if (filter.value === "active") {
                              return row.active;
                            }
                            return false;
                          },
                          Filter: ({ filter, onChange }) => (
                            <select
                              onChange={event => onChange(event.target.value)}
                              style={{ width: "100%" }}
                              value={filter ? filter.value : "all"}>
                              <option value="all">
                                {intl.formatMessage({ id: "tout" })}
                              </option>
                              <option value="active">
                                {intl.formatMessage({
                                  id: "ids_active"
                                })}
                              </option>
                            </select>
                          )
                        },                        
                        {
                          id: "name",
                          name: "name"
                        },
                        {
                          name: "client",
                          accessor: "tiersClient.name"
                        },
                        {
                          name: "type"
                        },
                        {
                          name: "tiersCollaborator",
                          accessor: "tiersCollaborator.name"
                        },
                        {
                          name: "finPrevue",
                          type: "date"
                        }
                      ]}
                      data={projectsList}
                      onRowClick={(project, index) => {
                        history.push(`/settings/projects/${project}/edit`);
                      }}
                      onRowSelect={() => null}
                      selectRow={false}
                      defaultSorted={[
                        {
                          id: "name",
                          desc: false
                        }
                      ]}
                    />
                  }
                />
              </Col>
            </Row>
          </div>
        </div>
      </Grid>
    </span>
  );
};

export default withRouter(injectIntl(ProjectSettingsList));
